<template>
  <v-app>
  <v-list class="pt-0 d-flex flex-column" color="#294A66" min-height="100dvh">
    <div class="d-flex align-center justify-center">
      <v-avatar
        size="30"
        tile
        class="ml-2"
        style="border:solid white"
      >
        <v-img
          class="preview-item-file"
          :src="logoSrc"
          alt=""
        />
      </v-avatar>
      <h3 class="white--text text-center" style="width:100%;">{{basetitle}}</h3>
    </div>

    <!--ホーム-->
    <v-list class="pb-0 pt-0" :class="{ selectedBack: $route.name === 'sp_home' }" @click="today()">
      <router-link to="/home" style="text-decoration:none;">
      <v-list-item class="pb-0 listgroup">
        <v-list-item-icon class="pt-3">
          <v-img
            v-if="$route.name === 'sp_home'"
            src="../../assets/svg/home.svg"
            alt=""
            width="20px"
          ></v-img>
          <v-img
            v-else
            src="../../assets/svg/home.svg"
            alt=""
            width="20px"
          ></v-img>
        </v-list-item-icon>
        <v-list-item-content class="ml-4">
          <v-list-item-title class=" white--text" :class="{ selectedFont: $route.name === 'sp_home' }"
            >ホーム</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      </router-link>
    </v-list>

    <v-list-group
      v-for="item in navlid"
      :key="item.id"
      v-model="item.active"
      no-action
      class="listgroup"
      :class="{ navilidr: $route.params.id === item.id }"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-row>
            <v-col cols="3">
              <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
              <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                color="deepLava"
                overlap
              >
                <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
              </v-badge>   
              <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
            </v-col>
            <v-col cols="9" class="d-flex align-center rounded-l-pill white--text" :class="{ thispage: $route.params.id === item.id }">
              <v-list-item-title
                style="width: 150px;"
              >{{ item.title }}</v-list-item-title>
            </v-col>
          </v-row>
        </v-list-item-content>
      </template>
      <v-row v-if="item.isfolder">
        <v-col cols="2"></v-col>
        <v-col cols="10">
          <v-list-item v-for="childitem in item.childlids" :key="childitem.id" class="pr-0">
            <v-menu right offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#008CFF"
                  class="childitembtn"
                  dark
                  width="100%"
                  height="60px"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ childitem.title }}
                </v-btn>
              </template>
              <v-list elevation="10" style="background-color: #E0E0E0" @click="today()">
                <router-link :to="'/sp/' + childitem.id + '/content'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        src="../../assets/svg/3002.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        style="color: #294A66"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('前提情報')}}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
                <router-link :to="'/sp/' + childitem.id + '/idea'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        src="../../assets/svg/3012.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        style="color: #294A66"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('アイデア')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
                <router-link :to="'/sp/' + childitem.id + '/project'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        src="../../assets/svg/3013.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        style="color: #294A66"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('プロジェクト')}}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </v-list>
            </v-menu>
        </v-list-item>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="2"></v-col>
        <v-col cols="10" @click="today()">
          <router-link :to="'/sp/' + item.id + '/content'" style="text-decoration:none;">
            <v-list-item class="pr-0">
              <v-list-item-icon class="pt-2">
                <v-img src="../../assets/svg/3002.svg" alt="" width="10px" v-if="$route.name === 'sp_content'&&aboutLid.id==item.id"></v-img>
                <v-img src="../../assets/svg/3002gray.svg" alt="" width="10px" v-else></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title class="text-caption white--text rounded-l-pill pa-1" :class="{select: $route.name === 'sp_content'&&aboutLid.id==item.id}" style="color:#2b2b2b;">{{$t('前提情報')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
            <!--:class="!item.read_idea.includes(uid) ? 'pl-10' : 'pl-16'" <v-icon class="mr-2" color="#ba0009" v-if="!item.read_idea.includes(uid)">mdi-new-box</v-icon>-->  
          <router-link :to="'/sp/' + item.id + '/idea'" style="text-decoration:none;">
            <v-list-item class="pr-0">
              <v-list-item-icon class="pt-2">
                <v-img v-if="(ideatf&&aboutLid.id==item.id)" src="../../assets/svg/3012.svg" alt="" width="10px"></v-img>
                <v-img v-else src="../../assets/svg/3012gray.svg" alt="" width="10px"></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title class="text-caption rounded-l-pill pa-1" :class="{select: ideatf&&aboutLid.id==item.id}" :style="item.isNotiIdea&&isAuthed ? 'color: #E64550' : 'color: #ffffff'">{{$t('アイデア')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="'/sp/' + item.id + '/project'" style="text-decoration:none;">
            <v-list-item class="pr-0">
              <v-list-item-icon class="pt-2">
                <v-img v-if="(pjtf&&aboutLid.id==item.id)" src="../../assets/svg/3013.svg" alt="" width="10px"></v-img>
                <v-img v-else src="../../assets/svg/3013gray.svg" alt="" width="10px"></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title class="text-caption white--text rounded-l-pill pa-1" :class="{select: pjtf&&aboutLid.id==item.id}" style="color:#2b2b2b;">{{$t('プロジェクト')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-col>
      </v-row>
    </v-list-group>

    <!-- 一時的に見出し追加 -->
    <v-list v-if="alid.length>0" class="mt-4" style="background-color: #2b2b2b !important;">
      <v-list-item>
        <v-list-item-title class="selectedFont text-subtitle-1 font-weight-bold">(非公開) 庁内運用↓</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list-group
      v-for="item in alid"
      :key="item.id"
      v-model="item.active"
      no-action
      class="listgroup px-2"
      :class="{ navilidr: $route.params.id === item.id }"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-row>
            <v-col cols="3">
              <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
              <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                color="deepLava"
                overlap
              >
                <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
              </v-badge>   
              <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
            </v-col>
            <v-col cols="9" class="d-flex align-center rounded-l-pill white--text" :class="{ thispage: $route.params.id === item.id }">
              <v-list-item-title
                style="width: 150px;"
              >{{ item.title }}</v-list-item-title>
            </v-col>
          </v-row>
        </v-list-item-content>
      </template>
      <v-row v-if="item.isfolder">
        <v-col cols="2"></v-col>
        <v-col cols="10">
          <v-list-item v-for="childitem in item.childlids" :key="childitem.id" class="pr-0">
            <v-menu right offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#008CFF"
                  class="childitembtn"
                  dark
                  width="100%"
                  height="60px"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ childitem.title }}
                </v-btn>
              </template>
              <v-list elevation="10" style="background-color: #E0E0E0" @click="today()">
                <router-link :to="'/sp/' + childitem.id + '/content'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-icon color="#008CFF" width="10px">mdi-information-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        style="color: #294A66"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('前提情報')}}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
                <router-link :to="'/sp/' + childitem.id + '/idea'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        src="../../assets/svg/3012.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        style="color: #294A66"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('アイデア')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
                <router-link :to="'/sp/' + childitem.id + '/project'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        src="../../assets/svg/3013.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        style="color: #294A66"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('プロジェクト')}}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </v-list>
            </v-menu>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="2"></v-col>
        <v-col cols="10" @click="today()">
          <router-link :to="'/sp/' + item.id + '/content'" style="text-decoration:none;">
            <v-list-item class="pr-0">
              <v-list-item-icon class="pt-2">
                <v-img src="../../assets/svg/3002.svg" alt="" width="10px" v-if="$route.name === 'sp_content'&&aboutLid.id==item.id"></v-img>
                <v-img src="../../assets/svg/3002gray.svg" alt="" width="10px" v-else></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title class="text-caption white--text rounded-l-pill pa-1" :class="{select: $route.name === 'sp_content'&&aboutLid.id==item.id}" style="color:#2b2b2b;">{{$t('前提情報')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
            <!--:class="!item.read_idea.includes(uid) ? 'pl-10' : 'pl-16'" <v-icon class="mr-2" color="#ba0009" v-if="!item.read_idea.includes(uid)">mdi-new-box</v-icon>-->  
          <router-link :to="'/sp/' + item.id + '/idea'" style="text-decoration:none;">
            <v-list-item class="pr-0">
              <v-list-item-icon class="pt-2">
                <v-img v-if="(ideatf&&aboutLid.id==item.id)" src="../../assets/svg/3012.svg" alt="" width="10px"></v-img>
                <v-img v-else src="../../assets/svg/3012gray.svg" alt="" width="10px"></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title class="text-caption rounded-l-pill pa-1" :class="{select: ideatf&&aboutLid.id==item.id}" :style="item.isNotiIdea&&isAuthed ? 'color: #E64550' : 'color: #ffffff'">{{$t('アイデア')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="'/sp/' + item.id + '/project'" style="text-decoration:none;">
            <v-list-item class="pr-0">
              <v-list-item-icon class="pt-2">
                <v-img v-if="(pjtf&&aboutLid.id==item.id)" src="../../assets/svg/3013.svg" alt="" width="10px"></v-img>
                <v-img v-else src="../../assets/svg/3013gray.svg" alt="" width="10px"></v-img>
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                <v-list-item-title class="text-caption white--text rounded-l-pill pa-1" :class="{select: pjtf&&aboutLid.id==item.id}" style="color:#2b2b2b;">{{$t('プロジェクト')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-col>
      </v-row>
    </v-list-group>

    <v-list class="mt-auto py-0" v-if="!isAuthed">
      <v-list-item @click="authModal = true">
        <v-list-item-icon class="mr-4">
          <v-icon color="white">mdi-login-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-0">
          <v-list-item-title class=" white--text">ログイン/アカウント作成</v-list-item-title>
        </v-list-item-content>
      </v-list-item> 
    </v-list>
    <v-list class="mt-auto py-0" v-else>  
      <v-list-item @click="profileModal = true">
        <v-list-item-icon class="mr-4">
          <v-img
            v-if="profImageS"
            class="preview-item-file rounded-circle"
            width="50px"
            height="50px"
            :src="profImageS"
            alt=""
          ></v-img>
          <v-img
            v-else
            src="../../assets/svg/プロフィールアイコン.svg"
            alt=""
            width="10px"
          ></v-img>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class=" white--text">{{ currentName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="signout()">
        <v-list-item-icon class="mr-4">
          <v-icon color="white">mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class=" white--text">ログアウト</v-list-item-title>
        </v-list-item-content>
      </v-list-item>      
    </v-list>
    <v-list class="py-0">
      <v-list-item @click="settings = true">
        <v-list-item-icon class="mr-4">
          <v-img
            src="../../assets/svg/設定歯車アイコン.svg"
            alt=""
            width="10px"
          ></v-img>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class=" white--text">設定</v-list-item-title>
        </v-list-item-content>
      </v-list-item> 
    </v-list>
    <div v-if="navi_updateDate" class="pa-1 white--text text-center">
      <p>最終更新：{{ todayy }}</p>
    </div>
  </v-list>

    <!--設定画面-->
    <v-dialog fullscreen v-model="settings" height="120%" width="120%">
      <settings :members="members" @closeSetting="closeSettings" :isSp="true"></settings>
    </v-dialog>

    <!--サインイン画面-->
    <v-dialog fullscreen v-model="authModal">
      <auth-view
        v-if="authModal"
        defaultView="chooseauth"
        @closeModal="closeAuthModal"
      >
      </auth-view>
    </v-dialog>

    <!--プロフィール画面-->
    <profile_display
      :profile="profileModal"
      :profuid="uid"
      device="sp"
      @closeProfile="closeProfile"
    />
    <!-- 初期・通知確認画面 -->
    <firstUserSetting v-if="askForNotificationModalOpened&&!attributionModalOpened" />
    <!-- アンケート画面 -->
    <attribution v-if="attributionModalOpened" />
    <!-- 重要なお知らせ画面 -->
    <importantAnnounce v-if="importantAnnounceModalOpened" />
  </v-app>
</template>
 
<script>
import firebase from 'firebase'
// import authView from '../../components/auth/authView.vue';
// import profile_display from "../../components/profile/profile_display.vue";
// import settings from '../../components/settings.vue';
// import firstUserSetting from '../../components/firstUserSetting.vue';
const profile_display = () => import('../../components/profile/profile_display.vue')
const authView = () => import('../../components/auth/authView.vue')
const settings = () => import('../../components/settings.vue')
const firstUserSetting = () => import('../../components/firstUserSetting.vue')
const attribution = () => import('../../components/attributionSettingModal.vue')
const importantAnnounce = () => import('../../components/importantAnnounceModal.vue')
export default {
  components:{
    authView,
    profile_display,
    settings,
    firstUserSetting,
    attribution,
    importantAnnounce
  },
  data () {
    return {
      db: null,
      drawer: false,
      authModal: false,
      profileModal:false,
      settings:false,
      profImageS:"",
      defaultAuthView: "chooseauth",
      todayy: "",
    }
  },
  computed:{
    navi_updateDate(){
      if(this.$store.state.config.setting&&this.$store.state.config.setting.navi_updateDate) return this.$store.state.config.setting.navi_updateDate
      else return false
    },
    logoSrc() {
      return this.$store.state.logoSrc;
    },
    members(){
      return this.$store.state.members
    },
    namelist(el){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    config(){
      return this.$store.state.config
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    lid(){
      return this.$store.state.lid
    },
    navlid() {
      return this.$store.state.navlid;
    },
    alid() {
      return this.$store.state.alid;
    },
    getSelectColor() {
      return this.inspirecolor(this.postcolor);
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    isGovStaff() {
      return this.$store.state.auth?.user?.isGovStaff || false;
    },
    askForNotificationModalOpened() {
      return this.$store.state.auth.data.askForNotificationModalOpened;
    },
    attributionModalOpened() {
      return this.$store.state.auth.data.attributionModalOpened;
    },
    importantAnnounceModalOpened() {
      return this.$store.state.importantAnnounceModalOpened;
    },
    ideatf(){
      if (this.$route.name === "sp_idea") {
        return true;
      }else{
        return false;
      }
    },
    pjtf(){
      if(this.$route.name === "sp_project"){
        return true;
      }else{
        return false;
      }
    },
    attf(){
      if (this.$route.name === "sp_home") {
        return true;
      }else{
        return false;
      }
    },
  },
  created(){
    this.db = firebase.firestore()
    this.today()
  },
  methods: {
    signout() {
      this.$store.dispatch("auth/logout");
    },
    getProfimg(uid){
      //console.log("getpro",uid,this.isAuthed)
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .get()
        .then((doc) => {
          //プロフィールの取得
          //this.profImageO = doc.data().profImageO;
          this.profImageS = doc.data().profImageS;
          //console.log("getpro",doc.data())
        });
    },
    closeAuthModal() {
      this.authModal = false
    },
    closeProfile() {
      this.profileModal = false;
    },
    closeSettings(el){
      this.settings = el
    },
    toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + "/" + mm + "/" + dd + "  " + hh + ":" + mi + ":" + se
      //console.log("today",this.todayy)
    }  
  }
}
</script>
 
<style scoped>
.thispage {
  background-color: #ffffff !important;
  color: #294A66 !important;
  font-weight: bold;
}
.selectedBack{
  background-color: #707070 !important;
}
.selectedFont{
  color: #ffffff !important;
}
.select {
  color: #294A66 !important;
  background-color: white;
}
.listgroup .v-list-item__icon{
  margin: 0px !important;
}
.listgroup .v-list-group__header__prepend-icon{
  padding-top: 7% !important;
  padding-right: 1% !important;
  margin-right: 1% !important;
}
.listgroup .v-list-group__header{
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.selectedBack {
  background-color: #707070 !important;
}
.selectedFont {
  color: #ffffff;
}
.lidbtn {
  background-color: #CCE8FF !important;
  color: #2b2b2b !important;
}
.childitembtn{
  justify-content: start;
}
.navilidr >>> .v-list-group__header__append-icon{
  background-color: #ffffff;
  height: 60px !important;
  margin-left: 0px !important;
  padding-right: 16px !important;
}
.navilidr >>> .v-list-item--link{
  padding-right:0px !important;
}
*{
  font-family:mplus-2c-medium !important;
}
</style>